<div class="marginBottom-m">
  <vy-avatar-name
    [avatarInput]="accountManagementViewModel.userAvatar"
    [label]="accountManagementViewModel.userEmail"
  ></vy-avatar-name>
</div>

<div class="marginBottom-m">
  <vy-menu-vertical [variant]="menuVerticalVariantEnum.SECONDARY" [items]="accountManagementViewModel.navigationList">
  </vy-menu-vertical>
</div>

<vy-text-link
  [iconLeft]="true"
  [label]="'header_component.logged_user_menu.log_out'"
  [iconClass]="'ds-icon-logout'"
  (handleClick)="closeSession()"
></vy-text-link>
